export enum WorkloadAssociatedItem {
  PRODUCT,
  ENTERPRISE,
  BUSINESS,
  RMA,
}
